import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageGenericPrismic} from '../components/page-generic-prismic';

export interface SwapoutsPageProps {}

@inject(deps) @observer
export class SwapoutsPage extends Component<SwapoutsPageProps> {
  render() {
    return (
      <PageGenericPrismic
        model={this.props.model.page.swapouts}
      />
    )
  }
}